"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signOut = void 0;
var signOut = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1440q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h320q13 0 22.5 9.5t9.5 22.5q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-66 0-113 47t-47 113v704q0 66 47 113t113 47h288 11 13t11.5 1 11.5 3 8 5.5 7 9 2 13.5zM1568 896q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288h-448q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h448v-288q0-26 19-45t45-19 45 19l544 544q19 19 19 45z"
    }
  }]
};
exports.signOut = signOut;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/signOut.js
// module id = 1102
// module chunks = 0